import type { Payment } from '@kanda-libs/ks-frontend-services';

export const getLatestPayment = (payments?: Payment[]): Payment | undefined => {
  if (!payments || payments.length === 0) return undefined;
  if (payments.length === 1) return payments[0];
  return payments.sort(
    (p1, p2) =>
      new Date(p2.metadata?.created_at ?? 0).getTime() -
      new Date(p1.metadata?.created_at ?? 0).getTime(),
  )[0];
};
